import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '../useSonarSelector';
const selector = createSonarSelector((state) => state.application.periscope.cards.length);
export function usePeriscopeCount() {
    return useSonarSelector(selector);
}
